/**
 * Ripristino della demo: cancella il database nel browser e lo ricrea da zero.
 *
 * La cancellazione non può avvenire mentre PGlite tiene aperto il database, per
 * questo si registra la richiesta e si ricarica la pagina: la esegue il gateway
 * al prossimo avvio, prima di aprire il database.
 */

const RESET_FLAG = 'bacco-demo-reset';

export function requestDemoReset(): void {
  try {
    sessionStorage.setItem(RESET_FLAG, '1');
  } catch {
    // Senza storage il ripristino non è possibile: la pagina si ricarica e basta.
  }
  window.location.reload();
}

export function consumeDemoResetRequest(): boolean {
  try {
    const requested = sessionStorage.getItem(RESET_FLAG) === '1';
    sessionStorage.removeItem(RESET_FLAG);
    return requested;
  } catch {
    return false;
  }
}
